import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { SnAlertComponent } from './components/alert';

@NgModule({
  imports: [CommonModule, SnIconModule, SnButtonModule],
  exports: [SnAlertComponent],
  declarations: [SnAlertComponent],
})
export class SnAlertModule {}
